import { Dropdown, Space } from "antd";
import type { MenuProps } from "antd";
import clsx from "clsx";
import { More } from "@/assets";

const CustomDropdown = ({
  menu,
  className,
  dropdownRender,
}: {
  menu?: MenuProps;
  className?: string;
  dropdownRender?: (originNode: React.ReactNode) => React.ReactNode;
}) => {
  return (
    <Dropdown
      menu={menu}
      placement="bottomRight"
      dropdownRender={dropdownRender}
    >
      <a
        className={clsx("pl-3 customMore", className)}
        onClick={(e) => e.preventDefault()}
      >
        <Space>
          <img src={More} alt="" srcSet="" />
        </Space>
      </a>
    </Dropdown>
  );
};

export default CustomDropdown;
